import type { Router } from '@angular/router';
import type { SwUpdate } from '@angular/service-worker';
import type { RuntimeKind } from '@app/core/tokens/infrastructure.tokens';
import type { RuntimeConfigService } from '@app/core/services/runtime-config.service';
import type { IAppUpdateAdapter } from './update-adapter';
import { CapgoUpdateAdapter } from './capgo-update.adapter';
import { WebSwUpdateAdapter } from './web-sw-update.adapter';

export const createUpdateAdapter = (
  runtimeKind: RuntimeKind,
  swUpdate: SwUpdate,
  router: Router,
  runtimeConfig: RuntimeConfigService,
): IAppUpdateAdapter =>
  runtimeKind === 'capacitor'
    ? new CapgoUpdateAdapter(() => runtimeConfig.load().then(() => runtimeConfig.functionsUrl))
    : new WebSwUpdateAdapter(swUpdate, router);
